import React from 'react';

const CustomAlert = ({ severity = 'info', title, children }) => {
  const colors = {
    info: '#1976d2',
    success: '#43a047',
    warning: '#ffa000',
    error: '#d32f2f',
  };

  const bgColor = colors[severity] || colors.info;

  return (
    <div
      style={{
        padding: '1rem',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between',
        backgroundColor: bgColor,
        color: '#fff',
        borderRadius: '4px',
      }}
    >
      <div>
        {title && <h1 style={{ margin: 0, fontSize: '2em'  }}><strong>{title}</strong></h1>}
        <div style={{fontSize: '1.5rem'}}>{children}</div>
      </div>
    </div>
  );
};

export default CustomAlert;
